export class OperationResult<T> {
    isSuccess: boolean;
    code: string;
    messageData: string;
    message: string;
    value: T;
  }